import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

import securityDetailsStyles from './securityDetails.module.css';
import commonStyles from '../../../../common/common.module.css';
import Grid from '@material-ui/core/Grid';

const styles = (theme: Theme) =>
  createStyles({
    blue: {
      color: 'var(--primaryblue)',
    },
    grey: {
      color: 'rgb(0,0,0,0.26)',
    },
    red: {
      color: 'red',
      fontSize: 26
    },
    green: {
      color: 'green',
      fontSize: 26
    },
    textFieldWidth: {
      width: '100%'
    },
    textField: {
      marginRight: '20px',
    },
    '@media(max-width:480px)':{
      textField: {
        marginRight: '0px !important',
      },
    },
  });

interface TruckInfoType {
  rfsNumber: string;
  truckPlateNumber: string;
};

interface SecurityDetailsProps {
  classes: any;
  loseFocus: (propertyName: string) => void;
  handleChange: (propertyName: string, event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
  truckInfo: TruckInfoType;
};

const truckDetails = (props: SecurityDetailsProps) => {
  const { classes } = props;

  return (
    <div className={ securityDetailsStyles.inputsTruckWrapper }>
      <Grid container direction="row" className={ securityDetailsStyles.inputsTruckcontainer } >
        
        <Grid item sm={6} className={ commonStyles.inputLabelWrapper }  >
          <label className={ commonStyles.inputLabel }>Truck Plate No</label>
          <TextField
            id='truckPlateNumber'
            value={ props.truckInfo.truckPlateNumber }
            onBlur={ () => props.loseFocus('truckPlateNumber') }
            onChange={ (event: React.ChangeEvent<HTMLInputElement>) => props.handleChange('truckPlateNumber', event) }
            variant='outlined'
            InputProps={{
              classes: { input: classes.input },
            }}
            InputLabelProps={{
              className: classes.blue,
            }}
            className={ classes.textField }
          />
        </Grid>

        <Grid item sm={6} className={ commonStyles.inputLabelWrapper }  >
          <label className={ commonStyles.inputLabel }>RFS Number</label>
          <TextField
            required
            disabled={ props.disabled }
            id='rfsNumber'
            value={ props.truckInfo.rfsNumber }
            onBlur={() => props.loseFocus('rfsNumber')}
            onChange={ (event: React.ChangeEvent<HTMLInputElement>) => props.handleChange('rfsNumber', event) }
            variant='outlined'
            InputProps={{
              classes: { input: classes.input },
            }}
            InputLabelProps={{
              className: classes.blue,
            }}
            className={ [classes.textField, securityDetailsStyles.rfsField].join(" ") }
          />
       </Grid>

      </Grid>
    </div>
  );
};

export default withStyles(styles)(truckDetails);
